// extracted by mini-css-extract-plugin
module.exports = {"pending":"Issues_pending__3i6bm","closed":"Issues_closed__3wd2e"};